import api from '@/helpers/api_helper';
import { apiUrls } from '@/constant/configure';
import type { TriggerType } from '@/types/dmAutomation';

/**
 * 자동DM 자동화 설명서(공개 콘텐츠). 스튜디오 백엔드.
 * GET /api/v1/automation-guides/{type} — 인증 불필요.
 * 미구현 type → 404 { placeHolder: "준비 중인 안내입니다." }
 */
const STUDIO = { baseURL: apiUrls.studio };
const PREFIX = '/api/v1/automation-guides';

export type AutomationGuideType = 'feed_comment_dm' | 'story_reply_dm' | 'dm_keyword';

/** 웹 트리거 타입 → 가이드 type */
export const TRIGGER_TO_GUIDE_TYPE: Record<TriggerType, AutomationGuideType> = {
    COMMENT_KEYWORD: 'feed_comment_dm',
    STORY_REPLY: 'story_reply_dm',
    DM_KEYWORD: 'dm_keyword',
};

export interface AutomationGuideStep {
    no: number;
    image: string | null;
    title: string;
    desc: string;
}

export interface AutomationGuide {
    title: string;
    subtitle: string;
    steps: AutomationGuideStep[];
    goodFor: string;
}

export const getAutomationGuide = async (type: AutomationGuideType): Promise<AutomationGuide> => {
    const res = await api.get(`${PREFIX}/${type}`, STUDIO);
    return res.data?.guide;
};
